// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3KTlE","requiredAsterisk":"Info_requiredAsterisk__3eMgX"};